import { GraphSystems, TestGraph } from "../types";
import { WASSERMAN_9_ENDPOINT } from "./endpoints";
import { fetcher } from "./utils";

export const getWasserman9GraphsData = async ({
    testId,
    systemId,
}: {
    testId: string;
    systemId?: GraphSystems;
}) => {
    let params = { test_id: testId } as {
        test_id: string;
        system_id?: GraphSystems;
    };
    if (systemId !== undefined) {
        params = { ...params, system_id: systemId };
    }

    const data = await fetcher(WASSERMAN_9_ENDPOINT, {
        params,
    });

    const { error } = data;
    if (error) {
        console.error(error);
        throw new Error(error);
    }
    return data as TestGraph<"wasserman-9">[];
};

export type Wasserman9GraphUpdate = Pick<
    TestGraph,
    | "peak1_status"
    | "peak2_status"
    | "peak3_status"
    | "response1_status"
    | "response2_status"
    | "slope_calculation_begin_value"
    | "slope_calculation_end_value"
> & {
    testId?: string;
    graph_id: string;
};

export const updateWasserman9Graph = async ({
    testId,
    graph_id,
    ...data
}: Wasserman9GraphUpdate) => {
    if (!testId) {
        throw new Error("Test ID is required");
    }
    const resData = await fetcher(WASSERMAN_9_ENDPOINT, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            test_id: testId,
            graph_id: graph_id,
        },
        body: JSON.stringify(data),
    });

    const { error } = resData;
    if (error) {
        console.error(error);
        throw new Error(error);
    }
    return resData as TestGraph;
};
